import styled from 'styled-components'
import { colors } from '../../../styles/constants'

export const Container = styled.div`
  display: flex;
  border-top: 1px solid #DADADA;
`

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`

export const Main = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`
export const TitleContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`

export const IconRound = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background-color: #FFF2EE;
`
export const Title = styled.h1`
  color: #222222;
  font-family:'Open sans';
  font-size: 20px;
  font-weight: 700;
  line-height: 27.24px;
  `
export const Subtitle = styled.h2`
  color: #555555;
  font-size: 14px;
  font-family:'Open sans';
  font-weight: 400;
  line-height: 19px;
  margin-top: 8px;
`

export const CaseHistory = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #DADADA;
`

export const FormMeta = styled.div`
  font-family: 'Open Sans';
  color: #555;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  strong {
    color: #222222;
    font-weight: 600;
    font-family: 'Open Sans';
    ${({ isTitle }) => isTitle && 'font-size: 16px;'}
  }
`
export const Form = styled.form`
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  & > * {
    flex: 1;
  }
  :not(:last-child) {
    margin-bottom: 36px;
  }
`
export const DatepickerContainer = styled.div`
  flex-basis: 327px;
  flex-grow: 0;
  height: 48px;
`
export const FieldTitle = styled.div`
  margin-bottom: 29px;
  border-top: 1px solid #DADADA;
  padding-top: 24px;
  color: #222222;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  margin-top: -14px;
`
export const FormActions = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  & > * {
    flex: 1;
  }
`

export const SaveAppointmentButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: ${({ disabled }) => (disabled ? colors.gray.default : colors.cyan.medium)};
  color: ${({ disabled }) => (disabled ? colors.gray.light : colors.white)};
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const CancelAppointmentButton = styled(SaveAppointmentButton)`
  background-color: ${colors.transparent};
  color: ${colors.cyan.medium};
  &:disabled {
    color: ${colors.gray.light};
    background: ${colors.transparent};
  }
`

export const AlertContainer = styled.div`
  margin-bottom: 24px;
`
